'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var _notificationSelector = require('./notificationSelector');

var _currentUserSelector = require('../user/currentUserSelector');

exports.default = (0, _reselect.createStructuredSelector)({
    fetchedTime: _notificationSelector.getFetchedTime,
    forcedPoll: _notificationSelector.getForcedPoll,
    isGuest: _currentUserSelector.isGuestSelector,

    notifications: _notificationSelector.modifiedElementsSelector,
    notificationUserIds: _notificationSelector.notificationUserIdsSelector
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/notificationPollManagerSelector.js
// module id = 2036
// module chunks = 0